module.exports = __webpack_public_path__ + "static/media/cost_blog_img.56fec15f.webp";